
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 204 204"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"play-round-cls-1",attrs:{"fill":"#1d1d1b","d":"M172.85 31.27a99.46 99.46 0 00-70.77-29.39H102a100.12 100.12 0 00-.08 200.24h.08a100.11 100.11 0 0070.85-170.85zM102 201.12h-.08A99.12 99.12 0 01102 2.88h.08a99.12 99.12 0 01-.08 198.24z"}}),_c('path',{attrs:{"fill":"#1d1d1b","d":"M94.98 111.87l19.75-9.87-19.75-9.87v19.74z"}})])
          )
        }
      }
    